import React, { useEffect, useState, useRef } from 'react';
import './Home.css';
import logo from '../assets/TT logo.png';
import bike1 from '../assets/Page 1 - Designer Laptop.png';
import bike2 from '../assets/Page 2 - Apple watch.png';
import bike3 from '../assets/Page 3 - Nintendo  switch.png';
import bike4 from '../assets/Page 4 - Macbook.png';
import bike5 from '../assets/Page 5 - Sony PlayStation, Steam Deck, Xbox.png';
import bike6 from '../assets/Page 6 -Drone & Action Camera.png';
import bike7 from '../assets/Page 7 Microsoft Studio ,PRO ,X box.png';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link } from 'react-router-dom';

const slidesData = [
  { backgroundText: 'Lapotop', image: bike1, link: '/laptop-viewer' },
  { backgroundText: 'Apple Watch', image: bike2, link: '/apple-watches' },
  { backgroundText: 'Nintendo OLED', image: bike3, link: '/nintendo-switch' },
  { backgroundText: 'MacBook', image: bike4, link: '/macbook' },
  { backgroundText: 'PlayStation/Steam', image: bike5, link: '/sony' },
  { backgroundText: 'Drone & Camera', image: bike6, link: '/drone' },
  { backgroundText: 'MS Studio / Xbox', image: bike7, link: '/ms-studio' },
];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const toggleMenu = () => setMenuOpen((s) => !s);

  // start auto slide loop
  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slidesData.length);
    }, 5000);
  };

  // call this after a manual interaction so auto-slide restarts after some time
  const resetAutoSlide = () => {
    clearInterval(intervalRef.current);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      startAutoSlide();
    }, 5000);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    resetAutoSlide();
  };

  useEffect(() => {
    startAutoSlide();
    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <>
      <div className="home">
        {/* NAVBAR */}
        <div className="navbar" style={{ marginTop: '-80px' }}>
          <div className="logo">
            <img src={logo} style={{ width: '300px', marginTop: '30px' }} alt="Logo" />
          </div>
          <div className="menu-toggle" onClick={toggleMenu}>&#9776;</div>
          <ul id="nav-links" className={menuOpen ? 'show' : ''}>
            <li>Home</li>
            <li>About Us</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* TABS */}
        <div className="tabs-wrapper">
          <div className="tabs">
            {slidesData.map((slide, index) => (
              <button
                key={index}
                className={`tab-btn ${currentSlide === index ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-pressed={currentSlide === index}
              >
                <img src={slide.image} alt={slide.backgroundText} className="tab-img" />
                <span className="tab-label">{slide.backgroundText}</span>
              </button>
            ))}
          </div>
        </div>

        {/* SLIDER */}
        <div className="slider" style={{ marginTop: '90px' }}>
          {slidesData.map((slide, index) => (
            <div key={index} className={`slide ${currentSlide === index ? 'active' : ''}`}>
              {/* ✅ product name visible above each image */}
              <h2 className="product-name">{slide.backgroundText}</h2>
              <Link to={slide.link} className="slide-content" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img className="bike-img" style={{ marginTop: '80px' }} src={slide.image} alt={`Slide ${index + 1}`} />
              </Link>
            </div>
          ))}
        </div>

      </div>
      {/* ABOUT US SECTION */}
      <section id="about" className="about-section">
        <div className="about-container">
          <h2>About Think Techie</h2>
          <p className="about-subtext">
            We’re a UAE-based electronics repair service dedicated to making device care
            simple, reliable, and hassle-free. From laptops to gaming consoles, our
            certified technicians provide doorstep pickup, expert repairs, and safe delivery.
          </p>

          <div className="about-grid">
            <div className="about-card">
              <h3>5+</h3>
              <p>Cities Covered</p>
            </div>
            <div className="about-card">
              <h3>Same Day</h3>
              <p>Dubai Repairs</p>
            </div>
            <div className="about-card">
              <h3>Free</h3>
              <p>Pickup & Delivery</p>
            </div>
            <div className="about-card">
              <h3>24/7</h3>
              <p>WhatsApp Support</p>
            </div>
          </div>

          <div className="about-extra">
            <p>
              Our goal is simple: <strong>take the stress out of repairs</strong>.
              With transparent pricing, fast turnaround times, and personalized support,
              we’ve built trust with thousands of customers across the UAE.
            </p>
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section id="services" className="services-section">
        <div className="services-header">
          <h2>Our Repair Services</h2>
          <p>
            We specialize in repairing all your favorite electronics and gaming devices.
            Professional service with genuine parts and quality guarantee.
          </p>
        </div>

        <div className="services-grid">
          {/* MacBook Repair */}
          <div className="service-card">
            <h3>MacBook Repair</h3>
            <p className='par'>Screen replacement, battery issues, keyboard repairs and more</p>
            <p className="devices"><strong>Devices we repair:</strong> MacBook Air, MacBook Pro, iMac</p>
            <strong>Common Fixes</strong>
            <ul className="common-fixes">
              <li>Cracked screen</li>
              <li>Battery replacement</li>
              <li>Keyboard issues</li>
            </ul>
            <p className="timeframe">⏱ 2–5 days</p>
            <button className="book-btn">Book Repair</button>
          </div>

          {/* Nintendo Switch */}
          <div className="service-card">
            <h3>Nintendo Switch Repair</h3>
            <p className='par'>Joy-Con drift, screen replacement, charging port fixes</p>
            <p className="devices"><strong>Devices we repair:</strong> Nintendo Switch, Switch Lite, Switch OLED</p>
            <strong>Common Fixes</strong>
            <ul className="common-fixes">
              <li>Joy-Con drift</li>
              <li>Screen replacement</li>
              <li>Charging port fix</li>
            </ul>
            <p className="timeframe">⏱ 1–3 days</p>
            <button className="book-btn">Book Repair</button>
          </div>

          {/* Steam Deck */}
          <div className="service-card">
            <h3>Steam Deck Repair</h3>
            <p className='par'>Button repairs, SSD upgrades, cooling system, maintainance</p>
            <p className="devices"><strong>Devices we repair:</strong> Steam Deck 64GB, 256GB, 512GB</p>
            <strong>Common Fixes</strong>
            <ul className="common-fixes">
              <li>Button sticking</li>
              <li>SSD upgrades</li>
              <li>Cooling system fix</li>
            </ul>
            <p className="timeframe">⏱ 2–4 days</p>
            <button className="book-btn">Book Repair</button>
          </div>

          {/* PlayStation */}
          <div className="service-card">
            <h3>PlayStation Repair</h3>
            <p className='par'>HDMI port fixes, overheating solutions, controller repairs</p>
            <p className="devices"><strong>Devices we repair:</strong> PS4, PS5, Controllers</p>
            <strong>Common Fixes</strong>
            <ul className="common-fixes">
              <li>HDMI port fix</li>
              <li>Overheating solutions</li>
              <li>Controller repairs</li>
            </ul>
            <p className="timeframe">⏱ 1–4 days</p>
            <button className="book-btn">Book Repair</button>
          </div>

          {/* iPhone & iPad */}
          <div className="service-card">
            <h3>iPhone & iPad Repair</h3>
            <p className='par'>Screen replacement, battery service, camera reapirs</p>
            <p className="devices"><strong>Devices we repair:</strong> iPhone, iPad, Apple Watch</p>
            <strong>Common Fixes</strong>
            <ul className="common-fixes">
              <li>Cracked screen</li>
              <li>Battery replacement</li>
              <li>Camera issues</li>
            </ul>
            <p className="timeframe">⏱ Same day – 2 days</p>
            <button className="book-btn">Book Repair</button>
          </div>

          {/* Gaming Accessories */}
          <div className="service-card">
            <h3>Gaming Accessories</h3>
            <p className='par'>Controller repairs, headset fixes, charging cables</p>
            <p className="devices"><strong>Devices we repair:</strong> Xbox Controllers, PS Controllers, Headsets</p>
            <strong>Common Fixes</strong>
            <ul className="common-fixes">
              <li>Stick drift</li>
              <li>Button issues</li>
              <li>Cable replacement</li>
            </ul>
            <p className="timeframe">⏱ 1–2 days</p>
            <button className="book-btn">Book Repair</button>
          </div>
        </div>

        <div className="more-devices">
          <h4>Don’t see your device?</h4>
          <p>
            We repair many more devices! Contact us on WhatsApp to check if we can help with your specific repair needs.
          </p>
          <button className="ask-btn">Ask About Your Device</button>
        </div>
      </section>

      {/* CUSTOMER REVIEWS SECTION */}
      <section id="reviews" className="reviews-section">
        <h2>What Our Customers Say</h2>
        <p>
          Don’t just take our word for it. Here’s what our satisfied customers across the UAE have to say
          about our repair services.
        </p>

        <div className="reviews-grid">
          <div className="review-card">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p>"Excellent service! My MacBook screen was replaced perfectly and works like new."</p>
            <div className="reviewer">
              <strong>Ahmed Al-Mansouri</strong>
              <span>MacBook Pro • Dubai</span>
            </div>
          </div>

          <div className="review-card">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p>"Quick fix for Joy-Con drift issue. Professional service and fair pricing."</p>
            <div className="reviewer">
              <strong>Sarah Johnson</strong>
              <span>Nintendo Switch OLED • Abu Dhabi</span>
            </div>
          </div>

          <div className="review-card">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p>"They fixed the overheating issue quickly. Great communication throughout."</p>
            <div className="reviewer">
              <strong>Omar Hassan</strong>
              <span>PlayStation 5 • Al Ain</span>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICE LOCATIONS SECTION */}
      <section id="locations" className="locations-section">
        <div className="locations-header">
          <h2>Service Locations</h2>
          <p>
            We provide electronics repair services across the UAE with convenient pickup and delivery options.
          </p>
        </div>

        <div className="locations-grid">
          <div className="location-card">
            <h3>Dubai</h3>
            <p>Multi area coverage</p>
            <ul>
              <li>✅ Home pickup & delivery available</li>
              <li>✅ Same day service</li>
            </ul>
            <button className="book-btn">Book in Dubai</button>
          </div>

          <div className="location-card">
            <h3>Abu Dhabi</h3>
            <p>City-wide coverage</p>
            <ul>
              <li>✅ Home pickup & delivery available</li>
              <li>✅ Next day service</li>
            </ul>
            <button className="book-btn">Book in Abu Dhabi</button>
          </div>

          <div className="location-card">
            <h3>Al Ain</h3>
            <p>Garden City area</p>
            <ul>
              <li>✅ Drop-off & pickup available</li>
              <li>✅ 2–3 days service</li>
            </ul>
            <button className="book-btn">Book in Al Ain</button>
          </div>

          <div className="location-card">
            <h3>Fujairah</h3>
            <p>Main city areas</p>
            <ul>
              <li>✅ Scheduled pickup available</li>
              <li>✅ 3–4 days service</li>
            </ul>
            <button className="book-btn">Book in Fujairah</button>
          </div>

          <div className="location-card">
            <h3>Ajman</h3>
            <p>Full emirate coverage</p>
            <ul>
              <li>✅ Home pickup & delivery available</li>
              <li>✅ Next day service</li>
            </ul>
            <button className="book-btn">Book in Ajman</button>
          </div>
        </div>

      </section>

      {/* MAP: all locations in one iframe */}
      <section id="map" className="map-section">
        <h2>Find Us Across the UAE</h2>
        <p>All our service locations on one interactive map. Tap a pin to book in that area.</p>
        <div className="map-embed">
          <iframe
            title="Service Locations Map"
            src="/locations-map.html"
            className="map-iframe"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="contact-section">
        <h2 style={{textAlign: 'center'}}>Contact Us</h2>
        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </section>
      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Logo" />
            <p>© {new Date().getFullYear()} Tech Trends. All rights reserved.</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li onClick={() => scrollToSection('home-top')}>Home</li>
              <li onClick={() => scrollToSection('services')}>Services</li>
              <li onClick={() => scrollToSection('about')}>About Us</li>
              <li onClick={() => scrollToSection('contact')}>Contact</li>
            </ul>
          </div>
          <div className="footer-socials">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="#"><FaFacebook /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedin /></a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Home;
